<template>
  <v-btn icon id="mode-switcher" :ripple="false" class="notification-btn" @click="changeTheme">
    <v-icon v-if="loading" class="rotating ml-2 mb-0.5" size="large" color="#708AA7">mdi-loading</v-icon>
    <v-icon v-else :loading="loading" :color="$vuetify.theme.dark ? 'greenMain' : '#171717'">
      {{ $vuetify.theme.dark ? "mdi-weather-sunny" : "mdi-weather-night" }}
    </v-icon>
  </v-btn>
</template>

<script>
import { ADMINS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("admins", [ADMINS__ACTIONS.CHANGETHEME]),

    async changeTheme() {
      this.loading = true;
      try {
        const res = await this[ADMINS__ACTIONS.CHANGETHEME]({ id: this.loggedAdmin?.id });
        if (res?.status === 200) {
          this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        }
      } catch (error) {
        console.error("Theme toggle failed:", error);
      } finally {
        this.loading = false;
      }
    }

  },
};
</script>

<style scoped>
.grey-back {
  color: rgba(87, 125, 158, 0.342);
  background: transparent;
  margin: 0 !important;
}
</style>
